"use client";

import React, { useEffect, useState } from "react";

import { PhotoIcon } from "@/components/icons";
import useWindowSize from "@/lib/hooks/useWindowSize";

type Props = {
  cardAlign?: "horizontal" | "vertical";
  itemRender?: { desktop?: number; mobile?: number };
};

function ArticleSkeleton({ cardAlign }: { cardAlign: string }) {
  return (
    <div className="animate-pulse flex flex-col gap-1">
      <div
        className={`w-full flex items-center justify-center ${
          cardAlign === "horizontal"
            ? "h-[122px] md:h-[166px]"
            : "h-[187px] md:h-[293px]"
        } bg-gray-300 mb-1`}
      >
        <PhotoIcon className="w-[40px] h-[40px] min-w-[40px] md:w-[80px] md:h-[80px] md:min8w-[40px]" />
      </div>
      <div className="h-[8px] bg-gray-300 opacity-50 w-[50%]" />
      <div className="h-[12px] bg-gray-300 w-full mb-2" />
      <div className="h-[8px] bg-gray-300 opacity-50 w-[30%]" />
    </div>
  );
}

export default function ArticleListSkeleton({
  itemRender = { desktop: 5, mobile: 2 },
  cardAlign = "vertical",
}: Props) {
  const windowSize = useWindowSize();

  const [windowWidth, setWindowWidth] = useState<number>(windowSize.width || 0);

  useEffect(() => {
    setWindowWidth(windowSize.width || 0);
  }, [windowSize]);
  return (
    <>
      {Array(windowWidth > 768 ? itemRender.desktop : itemRender.mobile)
        .fill(0)
        .map((item: number, index: number) => (
          <ArticleSkeleton key={index} cardAlign={cardAlign} />
        ))}
    </>
  );
}
